var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEyeBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.89835 8.0013C5.89835 9.42352 7.06258 10.5807 8.49998 10.5807C9.93087 10.5807 11.0951 9.42352 11.0951 8.0013C11.0951 6.57261 9.93087 5.41544 8.49998 5.41544C7.06258 5.41544 5.89835 6.57261 5.89835 8.0013ZM12.3244 4.03201C13.4626 4.9112 14.4317 6.19767 15.1276 7.80736C15.1797 7.93019 15.1797 8.07241 15.1276 8.18878C13.7358 11.4082 11.2577 13.3346 8.49998 13.3346H8.49348C5.74226 13.3346 3.26421 11.4082 1.87234 8.18878C1.8203 8.07241 1.8203 7.93019 1.87234 7.80736C3.26421 4.58797 5.74226 2.66797 8.49348 2.66797H8.49998C9.87884 2.66797 11.1862 3.14635 12.3244 4.03201ZM8.50076 9.60958C9.39182 9.60958 10.1203 8.88554 10.1203 7.99988C10.1203 7.10776 9.39182 6.38372 8.50076 6.38372C8.42271 6.38372 8.34466 6.39018 8.27312 6.40311C8.2471 7.11422 7.66174 7.68311 6.93978 7.68311H6.90726C6.88775 7.78655 6.87474 7.88998 6.87474 7.99988C6.87474 8.88554 7.6032 9.60958 8.50076 9.60958Z",
    fill: "#605BFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEyeBlue);
export default __webpack_public_path__ + "static/media/icon-eye-blue.109f639a4c1b22504d85ba8274206616.svg";
export { ForwardRef as ReactComponent };